//consent forms
export class Registration {
    last_Name: any='';
    first_Name: any='';
    date_Of_Birth: any='';
    gender: any='';
    practice_Code: any='';
    email_Address: any='';
    cell_phone: any='';
    zip: any='';
    state: any='';
    city: any='';
    address: any='';
    created_By: any='';
    modified_By: any='';
    location_Code: any='';
}
export class sendOPTRequest {

    cellPhone: any;
    email: any;
    firstName: any;
    lastName: any;
    locationID: any;
    dob: any;
    createdBy: any;
    practice_code:any;

}
export class LocationModel {
    locationCode: string;
    locationName: string;
}

export class ProviderModel {
    providerCode: string;
    providerName: string;
    providerPrefix: string;
}
export class appointmentReasonModel {
    reasonId: string;
    reasonName: string;
}